import { useApp } from './AppProvider';

const Footer = () => {
    const { notificationMessage } = useApp();

    return (
        <footer className="automate-footer">
            <div
                className={
                    notificationMessage === ''
                        ? 'notification notification-hidden'
                        : 'notification notification-shown'
                }
            >
                {notificationMessage}
            </div>
            <div className="footer-content-wrapper">
                {/* We will portal footers into this .content-wrapper */}
                <div className="content-wrapper" />
            </div>
        </footer>
    );
};

export default Footer;
